module.exports = __webpack_public_path__ + "img/cloud.92f93be2.png";